import React from 'react'
import _ from 'lodash'
import axios from 'axios'

import categoryUtil from '../util/category.util'
import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'
import {HeaderBlock} from '../widgets/layout/headerblock.component'
import {ActivitySearchResults} from './activitysearchresults.component'
import {SearchFilter} from '../widgets/searchfilter/searchfilter.component'
import {SearchFail} from '../widgets/searchfail.component'
import {ActivityItem} from './activityitem.component'


export class ActivitySearch extends React.Component {
    constructor(props) {
        super(props)

        this.state = this.defaultState()
        this._isMounted = false
        this._filterArray = categoryUtil.getFilters()
        this.queryMappings = categoryUtil.getQueryMappings()
        this._activeItems = 0
        this._isSearching = false
        this._refreshSearch = false
        this.executeQuery = _.debounce(this.executeQuery, 500)


        _.bindAll(this,
            'getResults',
            'secondarySearch',
            'updateActiveFilters',
            'activateSearchItem',
            'deActivateSearchItem',
            'updateActiveItems',
            'executeQuery'
        )
    }


    defaultState() {
        return {
            destID: this.props.leg.getIn(['destination', 'id']),
            results: null,
            loading: true,
            filters: null,
            activeFilters: []
        }
    }

    componentDidMount() {
        this._isMounted = true
        // THIS BLOCK LOADS ALL KEYS IN OUR FILTER ARRAY EVEN IF THEY DONT EXIST IN THE SEARCH RESULTS
        this.setState({filters: _.keysIn(this._filterArray)})
        this.getResults()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.leg.getIn(['destination', 'id']) !== this.state.destID) {
            // Destination changed
            this.setState({destID: nextProps.leg.getIn(['destination', 'id']), loading: true, results: null})
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.destID !== this.state.destID) {
            // Destination changed, search again
            this.getResults()
        }
        if (prevState.results !== this.state.results) {
            this._activeItems = 0
        }
        if (prevState.activeFilters !== this.state.activeFilters) {
            this._refreshSearch = true
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    getRadius(bounds) {
        let lat1 = bounds.south
        let lon1 = bounds.west
        let lat2 = bounds.north
        let lon2 = bounds.east

        if (!lat1 || !lon1 || !lat2 || !lon2) {
            return '10km'
        }

        var p = 0.017453292519943295    // Math.PI / 180
        var c = Math.cos
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
          c(lat1 * p) * c(lat2 * p) *
          (1 - c((lon2 - lon1) * p)) / 2

        let diameter = 12742 * Math.asin(Math.sqrt(a))

        // If we're going to be 10km for the radius, let's bump it up a bit
        if (diameter < 20) {
            diameter = 50
        }

        return Math.round(diameter / 2) + 'km'
    }

    getResults(keys = []) {
        // Need to get the lat/long
        let destLat = this.props.leg.getIn(['destination', 'location', 'latitude']) ? this.props.leg.getIn(['destination', 'location', 'latitude']) : this.props.leg.getIn(['destination', 'latitude'])
        let destLon = this.props.leg.getIn(['destination', 'location', 'longitude']) ? this.props.leg.getIn(['destination', 'location', 'longitude']) : this.props.leg.getIn(['destination', 'longitude'])
        // Need to set self for scope of ajax query
        let self = this
        if (destLat !== -1 && destLon !== -1 && destLat && destLon && !this._isSearching) {
            let exclude = []
            this.props.leg.get('activities').map((activity) => {
                exclude.push(activity.get('id'))
            })
            this._isSearching = true

            let destinationItem = this.props.leg.get('destination')
            let boundedRadius = destinationItem.getIn(['opencage', 'bounds']) ? this.getRadius(JSON.parse(destinationItem.getIn(['opencage', 'bounds']))) : '10km'

            axios
                .get('/api/v1/attractions/near/', {
                    params: {
                        latitude: destLat,
                        longitude: destLon,
                        types: keys,
                        limit: 20,
                        distance: boundedRadius,
                        skip: exclude.join()
                    }
                })
                .then(function(response) {
                    var data = response.data ? response.data.results : []
                    if (self._isMounted) {
                        self.setState(function(state) {
                            // We have some duplicates in the db, merging on place_id to avoid displaying dupes
                            let cleaned = _.uniqBy(data, function (e) {
                                return e.place_id
                            })
                            if (state.results) {
                                self._isSearching = false
                                let merged = _(this.state.results)
                                    .concat(cleaned)
                                    .groupBy('place_id')
                                    .map(_.spread(_.merge))
                                    .value()
                                return {
                                    results: merged,
                                    loading: false
                                }
                            } else {
                                self._isSearching = false
                                return {
                                    results: cleaned,
                                    loading: false
                                }
                            }
                        })
                        if (data.length < 10) {
                            // Trigger a second search
                            self._isSearching = true
                            self.secondarySearch(destLat, destLon, keys)
                        }
                    }
                })
        } else {
            this.setState({loading: false, results: []})
        }
    }

    activateSearchItem(activity) {
        this.setState({showSearchItem: true, selectedSearchItem: activity})
    }

    deActivateSearchItem() {
        this.setState({showSearchItem: false, selectedSearchItem: null})
    }

    secondarySearch(destLat, destLon, keys = []) {
        // Need to set self for scope of ajax query
        let self = this
        if (destLat !== -1 && destLon !== -1 && destLat && destLon) {
            // Search our data source
            axios
                .get('/api/v1/attractions/near/', {
                    params: {
                        latitude: destLat,
                        longitude: destLon,
                        keywords: keys,
                        per_page: 20
                    }
                })
                .then(function(response) {
                    var data = response.data ? response.data.data : []
                    if (self._isMounted) {
                        self.setState(function(state) {
                            // We have some duplicates in the db, merging on place_id to avoid displaying dupes
                            let cleaned = _.uniqBy(data, function (e) {
                                return e.place_id
                            })

                            if (state.results) {
                                let merged = _(this.state.results)
                                    .concat(cleaned)
                                    .groupBy('place_id')
                                    .map(_.spread(_.merge))
                                    .value()
                                return {
                                    results: merged,
                                    loading: false
                                }
                            } else {
                                return {
                                    results: cleaned,
                                    loading: false
                                }
                            }
                        })
                        self._isSearching = false
                    }
                })
        }
    }

    updateActiveFilters(newFilters) {
        this._activeItems = 0
        this.setState({activeFilters: newFilters})
    }

    updateActiveItems(inc) {
        this._activeItems += inc
        this.executeQuery()
    }

    executeQuery() {
        if (this._activeItems < 20 && !this._isSearching && this._refreshSearch) {
            this._refreshSearch = false // Only call this once....
            if (this.state.activeFilters.length > 1) {
                this.getResults(this.queryMappings[this.state.activeFilters].join())
            }
        }
    }


    render() {
        let results = null

        if (this.state.loading) {
            results = <LunaLoader style="basic"/>
        } else if (this.state.results.length === 0) {
            results = <SearchFail {...this.props} type="attraction"/>
        } else {
            results = <ActivitySearchResults
                {...this.props}
                activateSearchItem={this.activateSearchItem}
                availableFilters={this._filterArray}
                activeFilters={this.state.activeFilters}
                activities={this.state.results}
                updateActiveItems={this.updateActiveItems}/>
        }

        let header = 'More things to do in ' + this.props.leg.getIn(['destination', 'title'])

        if (this.state.showSearchItem) {
            return <ActivityItem {...this.props} goBack={ this.deActivateSearchItem } activeActivity={ this.state.selectedSearchItem }/>
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.OVERVIEW)} className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <HeaderBlock header={header} body="Explore the list below or add your own."/>
                        <SearchFilter updateActiveFilters={this.updateActiveFilters} filters={this.state.filters} filterMaps={this._filterArray}/>
                        {results}
                    </div>
                    <div className="view-right-col">
                        <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.ENTRY)}>
                            <i className="icon-circle_add"/><span>ADD MY OWN</span>
                        </a>
                    </div>
                </div>
            )
        }
    }
}
